import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import { CircularProgress, Alert, Typography, Box} from "@mui/material";
import moment from "moment";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { timeConfig, dateConfig, SET_EMPTY } from "config";
import { getPunchesReportData, date, time } from "utils/report";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import { properCase } from "utils";
import { udpatePunchStatus } from "utils/activity";
import { OTHER_TEAM } from "config/CONSTANTS";
import { INCOMPLETE_BG_INVALID, INCOMPLETE_BG_VALID, INCOMPLETE_STATUS} from "./../../../config/index"; 
import NoData from "utils/NoData";
export const IncompleteView = (props) => {
  const { approveForManager, selectedTeam, imtRole } = props;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(SET_EMPTY);
  const [data, setData] = useState([]);
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );
  useEffect(() => {
    setIsLoading(true);
    setLoadingError(SET_EMPTY);
    if (user.workerId && !userLoading) {
      // let endDate = moment(props.endDate || new Date()).toISOString();
      // let startDate = moment(endDate)
      //   .subtract(INCOMPLETE_NUM_OF_DAYS, "days")
      //   .toISOString();

      let endDate = endOfWeek(new Date(moment(new Date()).add(2, "weeks")));

      let startDate = startOfWeek(
        new Date(moment(new Date()).subtract(2, "weeks"))
      );

      let userWorkerId =
        selectedTeam === OTHER_TEAM
          ? approveForManager.managerId
          : user.workerId;

      getPunchesReportData(
        userWorkerId,
        moment(startDate).format(dateConfig.format4),
        moment(endDate).format(dateConfig.format4)
      )
        .then((data) => {
          if (data && data.length > 0) {
            console.log("incompletedd", data);
            let filterData = [...data];
            if (selectedTeam === OTHER_TEAM) {
              let delegateFor = user?.delegateFor;
              if (
                !(
                  delegateFor &&
                  approveForManager &&
                  delegateFor.includes(approveForManager.managerId)
                ) &&
                ((imtRole &&
                  imtRole !== "" &&
                  imtRole.toLowerCase() === "supervisor") ||
                  (!imtRole && user.isApprover))
              ) {
                filterData = filterData.filter(
                  (item) =>
                    item.worker &&
                    item.worker.approvingManager &&
                    item.worker.approvingManager.includes(user.workerId)
                );
              }
            }

            data = udpatePunchStatus(filterData);
            data = data.filter(function (e) {
              return e.status === INCOMPLETE_STATUS;
            });
            setData(data);
            setLoadingError(SET_EMPTY);
          } else {
            setLoadingError("pgReview.noPunchesToReport");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setLoadingError("pgReview.errLoadingWorkerList");
          console.error("ReportView: Err in getWorkerByMgr Response: ", err);
        });
    } else if (userLoading) {
      console.log("Continue loading google user's data from IRM DB!");
    } else {
      setIsLoading(false);
      setLoadingError("pgReview.errLoadingWorkerId");
      console.log(
        "ReportView: else in getWorkerByMgr condition: No Logged in worker details found!"
      );
    }
  }, [userLoading, props.month, approveForManager, selectedTeam]);

  const columns = [
    {
      accessorKey: "name",
      header: properCase(t("pgReview.tableHeads.name")),
      size: 80,
    },
    {
      accessorKey: "jobName",
      header: properCase(t("pgHome.lblJobFamily")),
      size: 50,
    },
    {
      accessorKey: "activityGroup",
      header: properCase(t("pgReview.tableHeads.activityGroup")),
      size: 60,
      Cell: ({ row }) => {
        let value = row.original.activityGroup;
        if (value.toUpperCase() === "TRANSACTIONAL") {
          return properCase(t("pgHome.reportlabel2Transcational"));
        } else if (value.toUpperCase() === "PROJECT") {
          return properCase(t("pgHome.reprotlabel3Project"));
        } else if (value.toUpperCase() === "NON-TRANSACTIONAL") {
          return properCase(t("pgHome.reportlabel1Non-Transactional"));
        } else if (value.toUpperCase() === "LEAVE") {
          return properCase(t("other.lblLeave"));
        } else if (value.toUpperCase() === "MEAL") {
          return properCase(t("other.tlMeal"));
        } else if (value.toUpperCase() === "BUILDING MOVES") {
          return properCase(t("other.tlbuildingmoves"));
        } else {
          return value;
        }
      },
    },
    {
      accessorKey: "buildingId",
      header: properCase(t("pgReview.tableHeads.buildingId")),
      size: 50,
    },
    {
      accessorKey: "jobProjectInfo",
      header: properCase(t("pgReview.tableHeads.projectInfo")),
      size: 70,
    },
    {
      accessorKey: "exceptionName",
      header: properCase(t("pgReview.tableHeads.exceptionType")),
      size: 80,
      Cell: ({ row }) => {
        let value = row.original.exceptionName;

        if (value.toUpperCase() === "MISSED CLOCK IN") {
          return properCase(t("pgPunch.btnMissedClockedIn"));
        } else if (value.toUpperCase() === "MISSED CLOCK OUT") {
          return properCase(t("pgPunch.btnMissedClockedOut"));
        } else {
          return value === "no exception" ? SET_EMPTY : value;
        }
      },
    },
    {
      accessorKey: "inLocalTS",
      header: properCase(t("pgReview.tableHeads.startDate")),
      size: 60,
      sort: true,
      Cell: ({ row }) => {
        let value = row.original.inLocalTS;
        return date(value);
      },
    },
    {
      accessorKey: "startTime",
      header: properCase(t("pgReview.tableHeads.startTime")),
      size: 50,
      sort: true,
      Cell: ({ row }) => {
        let value = row.original.inLocalTS;
        return time(value);
      },
    },
    {
      accessorKey: "outLocalTS",
      header: properCase(t("pgReview.tableHeads.endTime")),
      size: 50,
      sort: true,
      Cell: ({ row }) => {
        let value = row.original.outLocalTS;
        return time(value);
      },
    },
    {
      accessorKey: "duration",
      header: properCase(t("pgReview.tableHeads.duration")),
      size: 50,
    },
    {
      accessorKey: "status",
      header: properCase(t("pgReview.tableHeads.status")),
      size: 60,
      Cell: ({ row }) => {
        let dataIndex = row.index;
        const rowData = row.original;
        const {status, statusException} = rowData;
        // const { status, statusException, jobName } = data[dataIndex];
        console.log("datai", data);
        let link = (
          <>
            {statusException ? (
              // status.toUpperCase()
              status && status.toUpperCase() === "INCOMPLETE" ? (
                properCase(t("other.lblIncomplete"))
              ) : (
                status.toUpperCase()
              )
            ) : (
              <Link
                title={t("pgReview.tableStaticText.btnEdit")}
                style={{ textDecoration: "none" }}
                to={{
                  pathname: "/timesheet",
                  state: {
                    punch: data[dataIndex],
                    selectedWorker: data[dataIndex]["worker"],
                    //status: data.status
                  },
                }}
              >
                <Typography variant="body2" color="#1b75bc">
                  {
                    // status.toUpperCase()
                    status && status.toUpperCase() === "INCOMPLETE"
                      ? properCase(t("other.lblIncomplete"))
                      : status.toUpperCase()
                  }
                </Typography>
              </Link>
            )}
          </>
        );
        return link;
      },
    },
  ];
  
  const table = useMaterialReactTable({
    renderTopToolbarCustomActions: () => {
      return (
        <Box sx={{ margin: "15px" }}>
          <Typography variant="h6" sx={{color: "#58595B"}}>
            {properCase(t("other.lblIncompleteActivities"))}
          </Typography>
        </Box>
      );
    },
    columns,
    data: data,
    localization:{
      noRecordsToDisplay: <NoData/>,
      noResultsFound: <NoData/>
    },
    state:{
      isLoading: isLoading,
      showProgressBars: isLoading
    },
    muiCircularProgressProps:{
      sx:{
        ".MuiCircularProgress-circle":{
          transition:'none'
        }
      },
      variant: 'determinate'
    },
    muiSkeletonProps:{
      animation:'wave',
      height: 20
    },
    enablePagination: true,
    enableGrouping: true,
    defaultColumn: {
      minSize: 150,
    },
    columnResizeMode: "onChange",
    muiTableBodyCellProps: {
      align: "left",
    },
    muiTableHeadCellProps: {
      align: "left",
    },
    enableColumnPinning: true,
    enableStickyHeader: true,
    muiPaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      showRowsPerPage: true,
    },
    initialState: {
      density: "compact",
      pagination: {
        pageSize: 50,
      },
    },
    // muiTableBodyRowProps: ({row}) => {
    //   const { endDate, endTime, startDate, startTime } =
    //       row.original;
    //       const bgWithinRange = INCOMPLETE_BG_VALID;
    //       const bgOutOfRange = INCOMPLETE_BG_INVALID
    //     if (!(endDate && endTime && startDate && startTime)) {
    //       let applyColor =
    //         startDate &&
    //         moment().diff(moment(startDate, dateConfig.format3), "days") > 14
    //           ? bgOutOfRange
    //           : bgWithinRange;
    //       return {
    //         sx:{
    //           backgroundColor: applyColor
    //         }
    //       };
    //     }
    //   },
  });

  const useStyles = makeStyles((theme) => ({
    hideElem: {
      display: "none",
    },
  }));

  const classes = useStyles();
  return (
    <>
      {/* {isLoading ? (
        <>
          <CircularProgress />
          <Typography variant="body2">
            {t("pgReview.loadingGoogleUserDetails")}
          </Typography>
        </>
      ) : loadingError ? (
        <Alert severity="info">{t(loadingError)}</Alert>
      ) : null}
      <div className={isLoading || loadingError ? classes.hideElem : ""}> */}
        <MaterialReactTable table={table} />
      {/* </div> */}
    </>
  );
};

export const ts = (time) => {
  return time
    ? moment(time).format(timeConfig.format4) +
        " " +
        moment(time).format(dateConfig.format5)
    : null;
};

IncompleteView.propTypes = {
  month: PropTypes.any.isRequired,
};
export default IncompleteView;
